<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'barPieChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let _this = this;
            let colorArr = [
                new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                    [
                        {offset: 0, color:'#00cbf0' },
                        {offset: 1, color:'#0088d7' }
                    ]
                ),
                new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                    [
                        {offset: 0, color:'#db0c39' },
                        {offset: 1, color:'#ff406a' }
                    ]
                )
            ];
            let datasetArr = [_this.dataArray.datetime,_this.dataArray.data[0],_this.dataArray.data[1]];
            datasetArr[0].unshift('product');
            datasetArr[1].unshift(_this.dataArray.dataName[0]);
            datasetArr[2].unshift(_this.dataArray.dataName[1]);
            var option = {
                legend: {
                    y: 'bottom',
                    itemGap: 40,
                    itemWidth:12,
                    itemHeight:12,
                    icon:'Rect',
                    textStyle:{
                        color:'#4c4c4c'
                    },
                },
                grid: {
                    top: '40',
                    left: '5',
                    right:'32%',
                    bottom: '30px',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                color:colorArr,
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        fontSize:'14'
                    },
                    axisPointer: {
                        type : 'shadow'   
                    },
                    showContent: false
                },
                dataset: {
                    source: datasetArr
                },
                xAxis : [
                    {
                        type : 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            formatter: '{value}',
                            margin:15,
                            textStyle: {
                                color: '#8a8a99',
                            }
                        },
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        gridIndex: 0,
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            show:true,
                            formatter: '{value}',
                            margin:12,
                            textStyle: {
                                color: '#8a8a99',
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color:'#ebebeb',
                            }  
                        },
                    }
                ],
                
                 series : _this.getBarSeries(colorArr,datasetArr)
            };
            return option;
        },
        getBarSeries(colorArr,dataList){
            let seriesArr =[], _this = this;
            
            //let dataList =  _this.dataArray.data;
            for(var i=1;i<dataList.length;i++){
                let tempSeries = _this.setBarSeries(dataList[i][0], colorArr[i-1]);
                seriesArr.push(tempSeries);
            }
            
            let tempSeries1 = _this.setPieSeries(dataList);
            seriesArr.push(tempSeries1);
            return seriesArr;
        },
        setPieSeries(dataList){
            let _this = this;
            let series = {
                type: 'pie',
                id: 'pie',
                startAngle:0,
                center:['85%', '50%'],
                radius: ['42%', '56%'],
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            formatter: '{d}%'
                        },
                    }
                },
                encode: {
                    itemName:dataList[0][0],
                    value: dataList[0][1],
                    tooltip:dataList[0][1]
                }
            };
            return series;
        },
        setBarSeries(name,colorArr) {
            let series = {
                name:name,
                type:'bar',
                stack: 'two',
                barWidth: '11',
                itemStyle: {
                    normal:  {
                        color:colorArr
                    }
                },
                seriesLayoutBy: 'row'
            };
            return series;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.barOption());
            _this.chart.on('updateAxisPointer', function (event) {
                var xAxisInfo = event.axesInfo[0];
                if (xAxisInfo) {
                    var dimension = xAxisInfo.value + 1;
                   _this.chart.setOption({
                        series: {
                            id: 'pie',
                            label: {
                                formatter: '{d}%'
                            },
                            encode: {
                                value: dimension,
                                tooltip: dimension
                            }
                        }
                    });
                }
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/barPieChart.vue